import { TokenService } from "../TokenService";
const headers = TokenService.getHeaders();
const authorizationBearer = TokenService.getAuthorizationBearer();


export const GlobalScenarioAPIService = {

    getAll: async function () {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + `/api/GlobalScenario/GetGlobalScenarios/`, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)

            return { error: response };    
        }
    },

    add: async function (scenarioDto) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/GlobalScenario/AddGlobalScenario', {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer, 
                },
                body: JSON.stringify(scenarioDto)
            });
            return await response.json();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },

    getItemsByUserId: () => {
        return 'implement logic'
    },

    updateNodes: async function (userNodes) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/GlobalScenario/UpdateNodes', {
                method: "PUT",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer,
                },
                body: JSON.stringify(userNodes)
            });

            return await response;
        } catch (error) {
            if (process.env.NODE_ENV === 'development') {
                console.log('There was an error', error);
                console.log(userNodes);
            }
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response;
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },
};